var map = {
	"./en.json": [
		"5848"
	],
	"./es.json": [
		"dc65",
		"lang-es-json"
	],
	"./ru.json": [
		"cfbd",
		"lang-ru-json"
	],
	"./zh.json": [
		"4f54",
		"lang-zh-json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "e528";
module.exports = webpackAsyncContext;